import { setConfetti } from '@/slices/components';
import { useDispatch, useSelector } from '@/store';
import { useCallback, useRef } from 'react';

const DEFAULT_DURATION = 3000;

export const useConfetti = () => {
  const dispatch = useDispatch();
  const { confetti } = useSelector((state) => state.components_store);

  const stopPartyRef = useRef(() => {});
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const hideComponent = () => {
    if (confetti.show) {
      dispatch(
        setConfetti({
          show: false,
          running: false,
        }),
      );
    }
  };

  const stopParty = () => {
    dispatch(
      setConfetti({
        show: true,
        running: false,
      }),
    );
  };

  stopPartyRef.current = stopParty;

  const partyHard = useCallback(
    (options?: { duration?: number }) => {
      const duration = options?.duration ?? DEFAULT_DURATION;

      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }

      dispatch(
        setConfetti({
          show: true,
          running: true,
          duration,
        }),
      );

      timeoutIdRef.current = setTimeout(() => {
        stopPartyRef.current();
      }, duration);
    },
    [dispatch],
  );

  return {
    partyHard,
    stopParty,
    duration: confetti.duration ?? DEFAULT_DURATION,
    show: confetti.show,
    running: confetti.running,
    onConfettiComplete() {
      hideComponent();
    },
  };
};
